module.exports = __webpack_public_path__ + "static/media/the-dutch-5.0eb7db19.jpg";